import {
  SaveOutlined,PlusOutlined
} from "@ant-design/icons";
import { Divider, Select, Space, Tag, Form as AntForm } from "antd";
import axios from "axios";
import {
  Button,
  Card,
  DeleteButton,
  Form,
  Map,
  Modal,
  Table,
  TableCard,
  Input
} from "components";
import React, { useEffect, useState, useRef } from "react";
import { FaPen, FaPlus, FaDownload, FaFilter } from "react-icons/fa6";
import { Link, useLocation, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { type } from "@testing-library/user-event/dist/type";

const staticData = [47.9004627, 106.92232505]

function Warehouse_Details() {
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  // const [filterOpen, setFilterOpen] = useState(false);
  const [form] = Form.useForm();
  const { id } = useParams()
  const [ locationlat, setLocation] = useState([]);
  const [category, setCategory] = useState([]);
  const [brand, setBrand] = useState([]);
  const [optionsName, setOptionsName] = useState("");
  const inputRef = useRef(null);
  const status = [
    { label: <Tag color="error">Идэвхтэй</Tag>, value: 0 },
    { label: <Tag color="processing">Идэвхгүй</Tag>, value: 1 },
  ];
  useEffect(() => {
    getData();
    getCategory();
    getBrand();
    // getWarehouse();
    // getProducts();
    // getCostumer();
    // getPayment();
  }, []);
  console.log('data- ',editData);
  const getData = () => {
    setLoading(true);
    axios({
      method: 'get',
      url:`warehouse/${id}`,
      
    }).then((res) => {
      setData(res.data);
      setLocation([res.data.lat, res.data.lng]);
      
    }).catch((err) => {
    }).finally(() => setLoading(false))
  };
  // const getData = () => {
  //   setLoading(true);
  //   axios({
  //     method: "get",
  //     // url: "products",
  //   })
  //     .then((res) => {
  //       let tmp = [];
  //       res.data.map((item) => tmp.push({ 
  //         ...item, 
  //         deliverydate: dayjs(item.deliverydate),
  //         createdAt: dayjs(item.createdAt),
  //         orderdate: dayjs(item.orderdate),
  //         statusdate: dayjs(item.statusdate),
  //         updatedAt: dayjs(item.updatedAt),
  //       }))
  //       setData(tmp)
  //     })
  //     .catch((err) => {})
  //     .finally(() => setLoading(false));
  // };
  

  const columns = [
    {
      title: "№",
      dataIndex: "No",
      key: "No",
      width: 50,
      align: "center",
      cellRender: (e) => <span>{e.rowIndex + currentPage + 1}</span>,
    },
    {
      title: "Гарчиг",
      dataIndex: "name",
      key: "title",
    },
    {
      title: "Үйлдвэр",
      dataIndex: "manufacturer",
      key: "manufacturer",
    },
    {
      title: "Төрөл",
      dataIndex: "categoryName",
      key: "categoryName",
    },
    {
      title: "Хэмжээ",
      dataIndex: "size",
      key: "size",
    },
    {
      title: "Өнгө",
      dataIndex: "color",
      key: "color",
    },
    {
      title: "Код",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Үнэ",
      dataIndex: "price",
      key: "payedamount",
    },
    {
      title: "Үлдэгдэл",
      dataIndex: "balance",
      key: "balance",
    },
    {
      title: "Тайлбар",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 90,
      cellRender: ({ value, data }) => (
        <div className="action-cell flex items-center gap-2">
          <Button
            type="ghost"
            size="sm"
            icon={<FaPen />}
            onClick={() => handleEditButton(data)}
          />
          <DeleteButton onClick={() => handleDelete(data)} />
        </div>
      ),
    },
  ];

  const fields = [
    {
      label: "Гарчиг",
      name: "name",
      rules: [{ required: true, message: "Гарчиг оруулна уу" }],
      className: "col-span-6 mb-1",
      inputProps: {},
    }, 
    {
      label: "Үйлдвэр",
      name: "manufacturer",
      // rules: [{ required: true, message: "Гарчиг оруулна уу" }],
      className: "col-span-6 mb-1",
      inputProps: {},
    }, 
    // {
    //   label: "Төрөл",
    //   name: "categoryName",
    //   // type: "textarea",
    //   // rules: [{required: true, message: 'Төлсөн дүн оруулна уу'}],
    //   className: "col-span-6 mb-1",
    //   inputProps: {},
    // },
    {
      label : "Хэмжээ",
      name : 'size',
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label : "Өнгө",
      name : 'color',
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label : "Код",
      name : 'code',
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label: "Дүн",
      name: "price",
      type: "number",
      // rules: [{required: true, message: 'Төлсөн дүн оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label : "Үлдэгдэл",
      name : 'balance',
      type : 'number',
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      type: "component",
      component: (
        <div className=" col-span-6 ">
          <label className="text-gray-400">Ангилал</label>
          <Form.Item
            name="categoryid"
            className="mt-2"
            rules={[{ required: true, message: "Ангилал оруулна уу" }]}
          >
            <Select
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: "8px 0",
                    }}
                  />
                  <Space>
                    <Input
                      ref={inputRef}
                      style={{ height: "20px" }}
                      value={optionsName}
                      onChange={onNameChange}
                      autoFocus
                    />
                    {/* <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addCategory}
                    ></Button> */}
                  </Space>
                </>
              )}
              options={category}
            />
          </Form.Item>
        </div>
      ),
    },
    {
      type: "component",
      component: (
        <div className="col-span-6">
          <label className="text-gray-400">Брэнд</label>
          <Form.Item
            name="brandid"
            className="mt-2"
            // rules={[{ message: "Брэнд оруулна уу" }]}
          >
            <Select
              allowClear={true}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: "8px 0",
                    }}
                  />
                  <Space>
                    <Input
                      style={{ height: "20px" }}
                      ref={inputRef}
                      value={optionsName}
                      onChange={onNameChange}
                      autoFocus
                    />
                    {/* <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addBrand}
                    ></Button> */}
                  </Space>
                </>
              )}
              options={brand}
            />
          </Form.Item>
        </div>
      ),
    }, 
    {
      label: "Тайлбар",
      name: "description",
      type: "textarea",
      // rules: [{ required: true, message: 'Тайлбар оруулна уу' }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
  
  ];
  const getCategory = () => {
      axios({
        method: "get",
        url: "/categories",
      })
        .then((res) => {
          let tmp = [];
          res.data.map((item) =>
            tmp.push({ value: item.id, label: item.name, text: item.name })
          );
          setCategory(tmp);
        })
        .catch(() => {});
    };
      const getBrand = () => {
        axios({
          method: "get",
          url: "/brands",
        })
          .then((res) => {
            let tmp = [];
            res.data.map((item) =>
              tmp.push({ value: item.id, label: item.name, text: item.name })
            );
            setBrand(tmp);
          })
          .catch(() => {});
      };
  // const addCategory = () => {
  //     setOptionsName("");
  //     axios({
  //       method: "post",
  //       url: `/category`,
  //       data: { name: optionsName },
  //     })
  //       .then((res) => {
  //         getCategory();
  //       })
  //       .catch((err) => {})
  //       .finally(() => {});
  //   };
  const onNameChange = (event) => {
    setOptionsName(event.target.value);
  };
  const handleSubmit = (values) => {
    console.log('values -0 : ',values);
    setActionLoading(true);
    if (editData) {
      axios({
        method: "put",
        url: `/product`,
        data: {
          ...values,
          id: parseInt(editData.productid),
        },
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    } else {
      axios({
        method: "post",
        url: `/product`,
        data: {
          ...values
        },
      })
        .then((res) => {
          axios({
            method: "post",
            url: `/warehouseproduct`,
            data: {
              productid : res.data.id,
              warehouseid: data.id,
              qty : values.balance
            }
          }).then(()=>{
            getData();
          }).finally(() => {
            setActionLoading(false);
          });
          handleCancel();
        })
        .catch((err) => {
          setActionLoading(false);
        })
        
    }
  };

  const handleAddButton = (data) => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditButton = (data) => {
    console.log("Засварлах өгөгдөл:", data); 
    setEditData(data);
    setShowModal(true);
    form.setFieldsValue(data);
  };

  const handleDelete = (data) => {
    setActionLoading(true);
    axios({
      method: "delete",
      url: `/order/${data.id}`,
    })
      .then((res) => {
        getData();
        handleCancel();
      })
      .catch((err) => {})
      .finally(() => {
        setActionLoading(false);
      });
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    if (editData) {
      setEditData(null);
    } else {
      form.resetFields();
    }
  };
  return (
  <div className="mainCard px-10 ">
    <div className='mainCard  grid grid-flow-col gap-4'>
        <Card className='col-span-3 mb-4 grid' >
            <h1 className='text-2xl text-black-text font-medium'>Хаяг байршил</h1>
            {
              locationlat.length > 0 ? (
              <Map className={'h-[230px]'}
                value={locationlat}
                center={locationlat}
                onChange={() => {}} disabled={true} /> )
                : (
                    <svg aria-hidden="true" className="w-full h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                )
            }
            {/* <Map className={'h-[230px]'}
                value={staticData}
                ref={locationlat}
                onChange={() => {}} disabled={true} /> */}
        </Card>
      <div className='col-span-6 border drop-shadow-lg w-full border-gray-200 bg-white py-4 px-6 rounded-3xl mb-4'>
      <div className="flex font-sans ">
          {/* <div className="flex-none w-60 relative mr-4">
            <img  
            // src={`${process.env.REACT_APP_CDN_URL}${location.state.image}`}  
            alt="" className="absolute inset-0 w-full h-full object-cover " loading="lazy" />
          </div> */}
          <div className="flex-auto p-6">
            <div className="flex flex-wrap">
              <h1 className="flex-auto text-lg font-semibold text-slate-900">
              Нэр: {data.name}
              </h1>
              <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
              Төрөл: {data.type}
              </div>
              <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
              Хаяг: {data.location}
              </div>
            </div>
            <div className="flex items-baseline mt-4 mb-6 pb-6 border-b border-slate-200">
             
            </div>
            <div className="flex space-x-4 mb-6 text-sm font-medium">
             Тайлбар: {data.description}
            </div>
          </div> 
      </div>
      </div>
    
   
    </div> 
    <TableCard
      header={
        <div className="flex flex-col">
          <div className="w-full flex justify-between items-center gap-4">
            <h1 className="text-2xl font-medium">Агуулахын үлдэгдэл</h1>
            <div className="flex items-center gap-2">
              {/* <Button icon={<FaFilter />} onClick={() => setFilterOpen(true)}>
                Шүүлтүүр
              </Button> */}
              <Button icon={<FaDownload />} onClick={() => {}}>
                Татах
              </Button>
              <Button type="primary" icon={<FaPlus />} onClick={handleAddButton}>
                Нэмэх
              </Button>
            </div>
          </div>
        </div>
      }
    >     
      <Table dataSource={data.products} columns={columns} loading={loading} />
      <Modal
        style={{ maxWidth: "80%", minWidth: "70%" }}
        title={editData ? "Засах" : "Шинээр нэмэх"}
        open={showModal}
        onCancel={handleCloseModal}
      >
        <Form
          form={form}
          fields={fields}
          editData={editData}
          onFinish={handleSubmit}
          className={"gap-2"}
        >
          <div className="col-span-12 flex justify-end items-center gap-2 mt-5">
            <Button
              type="primary"
              onClick={() => form.submit()}
              loading={actionLoading}
              icon={<SaveOutlined />}
            >
              Хадгалах
            </Button>
            <Button onClick={handleCancel} disabled={actionLoading}>
              Цуцлах
            </Button>
          </div>
        </Form>
      </Modal>
      
    </TableCard>
    </div>
  );
}

export default Warehouse_Details;
